import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import ProfileOverview from "views/admin/profile";


// Auth Imports
import SignIn from "views/auth/SignIn";
import SignUp from "views/auth/SignUp";

// Icon Imports
import {
  MdHome,
  MdLock,
} from "react-icons/md";

const routes = [
  {
    name: "Inicio",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
    show:true
  },
  {
    name: "Facturación",
    layout: "/admin",
    path: "invoice/:monto/:folio/:empresa",
    icon: <MdHome className="h-6 w-6" />,
    component: <ProfileOverview />
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Sign In Callback",
    layout: "/auth",
    path: "callback-sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Sign Up",
    layout: "/auth",
    path: "sign-up",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignUp />,
  },
];
export default routes;
